// @ts-nocheck
/* eslint-disable */
import * as types from 'appRedux/actions/users';

const initialState = {
  request: false,
  success: false,
  error: '',
  message: null,
  roles: [],
  userList: [],
  isUpdateRequest: false,
  isUpdate: false,
  updateUserSuccessMsg: '',
  userDataById: {},
  statusUpdateResponse: null,
  addRequest: false,
  addSuccess: false,
  getUsersSuccess: false,
  pagination: {
    totalPages: null,
    total: null,
    perPage: null,
    currentPage: null,
  },
  filter: {
    status: [],
    roles: [],
  },
  showConfirmationModal: false,
  selectedUserId: null,
};

const getUserById = (userList, id) => {
  return userList.find((user) => user.id === +id);
};
const addUser = (userList, payload) => {
  return [...userList, payload.data];
};

const updateId = '';
const payload = {};

function userMgmtReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_PERMISSION_ROLE_REQUEST:
      return {
        ...state,
        request: true,
        isUpdateRequest: false,
        isUpdate: false,
        updateUserSuccessMsg: '',
      };

    case types.GET_PERMISSION_ROLE_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        roles: action.payload ? action.payload.data : [],
      };

    case types.GET_PERMISSION_ROLE_FAILURE:
      return {
        ...state,
        request: false,
        success: false,
        error: 'Something went wrong.',
      };

    case types.GET_ALL_USERS_REQUEST:
      return {
        ...state,
        request: true,
        success: false,
        getUsersSuccess: false,
        isUpdateRequest: false,
        isUpdate: false,
        updateUserSuccessMsg: '',
        addRequest: false,
        addSuccess: false,
        message: '',
      };

    case types.GET_ALL_USERS_SUCCESS:
      return {
        ...state,
        request: false,

        success: true,
        userList: [...action.payload.data],
        getUsersSuccess: true,
        pagination: {
          ...state.pagination,
          totalPages: action.payload.total_pages,
          perPage: action.payload.per_page,
          total: action.payload.total,
          currentPage: action.payload.current_page,
        },
      };

    case types.GET_ALL_USERS_FAILURE:
      return {
        ...state,
        request: false,
        usersRequest: false,
        success: false,
        error: action.payload ? action.payload.detail : 'Something went wrong.',
      };

    case types.ADD_USER_REQUEST:
      return {
        ...state,
        addRequest: true,
        addSuccess: false,
        addError: false,
        message: '',
      };

    case types.ADD_USER_SUCCESS:
      const newUserList = addUser(state.userList, action.payload);
      return {
        ...state,
        addRequest: false,
        addSuccess: true,
        message: action.payload ? action.payload.message : '',
        userList: newUserList,
      };

    case types.ADD_USER_FAILURE:
      return {
        ...state,
        addRequest: false,
        addSuccess: false,
        error: 'Something went wrong.',
      };

    case types.GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        userDataById: action.payload.data,
      };

    case types.UPDATE_USER_STATUS_REQUEST:
      return {
        ...state,
        request: true,
        success: false,
        statusUpdateResponse: null,
      };

    case types.UPDATE_USER_STATUS_SUCCESS:
      return {
        ...state,
        request: false,
        success: true,
        statusUpdateResponse: action.payload ? action.payload.message : null,
      };

    case types.UPDATE_USER_BY_ID_REQUEST:
      // updateId = action.id;
      // payload = action.payload;
      return {
        ...state,
        isUpdateRequest: true,
        isUpdate: false,
        updateUserSuccessMsg: '',
      };

    case types.UPDATE_USER_BY_ID_SUCCESS:
      return {
        ...state,
        isUpdateRequest: false,
        isUpdate: true,
        updateUserSuccessMsg: action.resp ? action.resp.message : '',
        userList: state.userList
          .filter((each) => each.id == updateId)
          .concat(payload),
      };

    case types.UPDATE_USER_BY_ID_FAILURE:
      return {
        ...state,
        isUpdateRequest: false,
        isUpdate: false,
        updateUserSuccessMsg: '',
        error: action.resp ? action.resp.detail : 'Something went wrong.',
      };

    case types.FILTER_USERS:
      return filterUsers(state, action);

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedUserId: action.payload.userId,
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
        selectedUserId: null,
      };

    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        userList: state.userList.filter((user) => user.id !== action.userId),
      };

    default:
      return state;
  }
}

const filterUsers = (state, action) => {
  const {
    payload: { type, values },
  } = action;
  return {
    ...state,
    filter: {
      ...state.filter,
      [type]: values,
    },
  };
};

export default userMgmtReducer;
